import.meta.glob([
  '../images/**',
  '../fonts/**',
]);

// Keep 3rd‑party libs here (no Velocity import; ui.js owns that)
import 'waypoints/lib/jquery.waypoints.js';
import 'waypoints/lib/shortcuts/sticky.js';
import 'bootstrap/dist/js/bootstrap.bundle';
import fitVids from 'fitvids';

// Optional SVG sprite
import sprite from 'virtual:svg-sprite';

// Router (single common loader per your structure)
import { loadEvents } from './routes/common';

// Inject sprite once (survives HMR)
if (sprite && !document.getElementById('svg-sprite')) {
  document.body.insertAdjacentHTML('beforeend', sprite);
}

// Kick off (keep your fitVids-on-main behavior)
window.jQuery(loadEvents);
window.jQuery(function () {
  fitVids('main');
});
